export const selectCommunication = (namespace) => ({ communication }) =>
  communication[namespace] || {};
